import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import {
  fetchMembers,
  setSearchParam,
  fetchInactiveMembers,
} from '../../actions/team';
import { PER_PAGE_LIMIT } from '../../constants';

const MemberSearch = ({ statusType }) => {
  const dispatch = useDispatch();
  const teamData = useSelector((state) => state.team);

  const handleSearch = (status) => {
    const params = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      page: teamData.page,
      limit: PER_PAGE_LIMIT,
      summaryList: false,
      filter: JSON.stringify({
        memberStatus: status,
        keyword: teamData.searchParam,
      }),
    };

    if (status === 'active') {
      dispatch(fetchMembers(params));
    }
    if (status === 'inactive') {
      dispatch(fetchInactiveMembers(params));
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSearch(statusType);
    }
  };
  return (
    <div className="input-group mb-3">
      <input
        className="form-control"
        placeholder="Search team member"
        type="text"
        aria-label="Search team member"
        aria-describedby="Search team member"
        onChange={(e) => dispatch(setSearchParam(e.target.value))}
        onKeyDown={handleKeyDown}
      />
      <Button
        variant="primary"
        onClick={() => {
          handleSearch(statusType);
        }}
      >
        <span className="mdi mdi-magnify" />
      </Button>
    </div>
  );
};
MemberSearch.propTypes = {
  statusType: PropTypes.string,
};
export default MemberSearch;
